import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { GenericModalConfig } from '@front-platform/content-builder';
import { genericModalResolveConfig } from '@front-platform/content-builder';
import { Component, computed, input } from '@angular/core';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';

import { ModalsService } from '@core/services/modals/modals.service';

interface GenericModalData {
  modalHandle: string;
}
export interface GenericModalRuntimeConfig {
  'content'?: unknown[];
  'handle'?: string;
}

export type GenericModalConfigInput = Partial<
  Omit<GenericModalConfig, keyof GenericModalRuntimeConfig> & GenericModalRuntimeConfig
>;
export type GenericModalResolvedConfig = Omit<GenericModalConfig, keyof GenericModalRuntimeConfig> &
  Partial<GenericModalRuntimeConfig>;
export interface GenericModalContract extends ConfigComponentContract<
  GenericModalConfigInput,
  GenericModalResolvedConfig
> {}

@Component({
  selector: 'app-generic-modal',
  templateUrl: './generic-modal.component.html',
  standalone: false,
})
export class GenericModalComponent implements GenericModalContract {
  readonly config = input<GenericModalConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<GenericModalConfig, GenericModalRuntimeConfig>(
    genericModalResolveConfig,
    () => ({ config: this.config() }),
  );
  readonly backgroundColor = computed(
    () => this.resolvedConfig()['background_color'] as unknown as IContentBuilderFieldColor,
  );
  get content(): unknown[] {
    return this.resolvedConfig()['content'] as unknown as unknown[];
  }
  get handle(): string {
    return this.resolvedConfig()['handle'] as unknown as string;
  }

  constructor(private readonly modalsService: ModalsService) {}

  close(): void {
    this.modalsService.close(this.handle);
  }

  getData(): GenericModalData {
    return {
      modalHandle: this.handle,
    };
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(GenericModalComponent, { 'keyAliases': {} });
